<template>
  <Modal
    class="account-modal"
    :isOpen="isOpen"
    :buttons="state.buttons"
    title="Paramètres de votre compte"
    @close="close()"
    @callbackBtn1="logout()"
  >
    <template #extra>
      <TabsNavigation
        :tabs="['Informations', 'Supprimer votre compte']"
        @changeTab="(value) => (state.currentTab = value)"
      />
      <transition mode="out-in" name="fade">
        <component :is="tabsContent[state.currentTab]" />
      </transition>
    </template>
  </Modal>
</template>

<script setup>
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import Informations from "./tabs/Informations.vue";
import DeleteAccount from "./tabs/DeleteAccount.vue";

const { logout } = useCandidateStore();

const tabsContent = [Informations, DeleteAccount];

const state = reactive({
  currentTab: 0,
  buttons: {
    column: false,
    data: [
      {
        label: "Se déconnecter",
        class: "red icon icon-left",
        icon: "bi-box-arrow-left",
      },
    ],
  },
});

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(["close"]);

function close() {
  state.currentTab = 0;
  emits("close");
}
</script>
